import * as React from "react";
import './Loader.module.scss';

import {ThreeDots} from "react-loader-spinner"


export const ThreeDotLoader = () => {
  return (
    <div className="DotLoaderHolder">
        <span className="d-flex justify-content-center align-items-center">
          <ThreeDots
            height={80}
            width={80}
            radius={9}
            color="#019A9E"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            visible={true}
          />
        </span> 
      </div>
  );
}

